__turbopack_context__.v({
  "active": "AUyota_active",
  "avatarContainer": "AUyota_avatarContainer",
  "backDrop": "AUyota_backDrop",
  "clickable": "AUyota_clickable",
  "logoAnchor": "AUyota_logoAnchor",
  "logoutLink": "AUyota_logoutLink",
  "menuCloseIcon": "AUyota_menuCloseIcon",
  "menuContainer": "AUyota_menuContainer",
  "menuContainerActive": "AUyota_menuContainerActive",
  "menuCopyright": "AUyota_menuCopyright",
  "menuItem": "AUyota_menuItem",
  "menuItemLink": "AUyota_menuItemLink",
  "menuOverlay": "AUyota_menuOverlay",
  "navigationWrapper": "AUyota_navigationWrapper",
});
